<template lang="pug">
.group-details
  .row(v-if="group")
    .col-sm-12
      .panel.panel-default
        .panel-heading
          .panel-title Group
          .text-center.loading(v-if="loading")
            i.fa.fa-spinner.fa-pulse.fa-spin
        .panel-body
          .container-fluid
            .row
              label.col-sm-2.control-label Name
              .col-sm-4 {{group.name}}
              label.col-sm-2.control-label Organization
              .col-sm-4 {{group.organization.name}}
            .row
              label.col-sm-2.control-label Parent Group
              .col-sm-4(v-if="parentGroup")
                a(@click="goToGroup(parentGroup)") {{parentGroup.name}}
            hr
            .row
              label.col-sm-2.control-label Child Groups
              .col-sm-10(v-if="childGroups")
                PillsList(:items="childGroupNames" :clickable="true" @itemClick="goToGroup")
            hr
            .row
              label.col-sm-2.control-label Roles
              .col-sm-10
                PillsList(:items="groupRoleValues")
            hr
            .row
              label.col-sm-2.control-label Implicit Roles
              .col-sm-10
                PillsList(:items="implicitGroupRoleValues")
  .row
    .col-sm-12
      DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)")
        tr(slot="thead")
          th Name
          th Email
          th Default Group
          th Enabled
          th
        tr(v-for="gu in groupUsers")
          td {{gu.username}}
          td {{gu.email}}
          td {{gu.defaultGroup.name}}
          td {{gu.enabled ? 'Yes' : 'No'}}
          td.actions
            a.btn-view(@click="goToUser(gu.id)") View
            a.btn-view(v-if="canBeRemoved(gu.defaultGroup.id)" @click="removeUserFromGroup(gu.id)" title="Remove from group") X

</template>

<script>
import Security from '@/service/apis/Security'
import DataGrid from '@/components/ssp/DataGrid'
import PillsList from '@/components/common/PillsList'

export default {
  props: {
    groupId: {
      type: Number
    }
  },
  data: () => ({
    group: null,
    childGroups: null,
    parentGroup: null,
    groupUsers: null,
    loading: false
  }),
  created() {
    this.init()
  },
  methods: {
    reload() {
      this.init()
      this.$refs.grid.reload()
    },
    init() {
      this.loading = true
      Security.getGroup(this.groupId)
        .then((resp) => {
          this.group = resp.data.group
          if (resp.data.group.parentId) {
            return resp.data.group.parentId
          }
        })
        .then((parentId) => {
          if (parentId) {
            Security.getGroup(parentId)
              .then((resp) => {
                this.parentGroup = resp.data.group
              })
          }
        })
        .then(() => {
          this.getChildGroups()
          this.loading = false
        })
    },
    fetchData(page) {
      const req = page.maxOffsetRequest()
      req.groupId = this.groupId
      return Security.listUsersNonPriv(req)
        .then((resp) => {
          this.groupUsers = resp.data.users.user
          return resp.data.totalRecords
        })
    },
    getChildGroups() {
      const req = {
        size: 1000,
      }
      Security.listChildGroups(this.groupId, req)
        .then((resp) => {
          this.childGroups = resp.data.content
        })
    },
    goToGroup(item) {
      this.$emit('goToGroup', item.id)
    },
    goToUser(id) {
      this.$emit('goToUser', id)
    },
    removeUserFromGroup(id) {
      this.$emit('removeUser', id)
    },
    canBeRemoved(id) {
      return this.groupId !== id
    }
  },
  watch: {
    groupId() {
      this.init()
      this.$refs.grid.reload()
    }
  },
  computed: {
    childGroupNames() {
      return this.childGroups
        .map((o) => ({ id: o.id, name: o.name }))
    },
    groupRoleValues() {
      return this.group.roles.role.filter((o) => !o.implicit)
        .map((g) => ({ id: g.id, name: g.value }))
    },
    implicitGroupRoleValues() {
      return this.group.roles.role.filter((o) => o.implicit)
        .map((g) => ({ id: g.id, name: g.value }))
    }
  },
  components: {
    DataGrid,
    PillsList
  }
}
</script>

<style lang="scss">
.group-details {
  .item+.item:before {
    content: ", "
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/management/group/GroupDetails.vue